import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyName'
})
export class CurrencyNamePipe implements PipeTransform {
  transform(currency: string, language: string): string {
    if (language === 'ar') {
      switch(currency) {
        case 'TND': return 'الدينار';
        case 'EUR': return 'اليورو';
        case 'USD': return 'الدولار';
        case 'DT': return 'الدينار';
        default: return currency;
      }
    }
    return currency;
  }
}